import {bp} from './namespace.js';

$.extend(true, bp, {
  bootstrap: (function () {
    'use strict';

    var bootstrap_environment = null;
    var previous_bootstrap_environment = null;
    var resize_event_timeout = null;

    $(document).ready(function () {
      $(window).resize(function () {
        window.clearTimeout(resize_event_timeout);
        resize_event_timeout = window.setTimeout(function () {
          var check_result = bp.bootstrap.check_bootstrap_environment();
          if (check_result !== bootstrap_environment) {
            previous_bootstrap_environment = bootstrap_environment;
            bootstrap_environment = check_result;
            $(window).trigger('bp-bootstrap-environment-change');
          }
        }, 500);
      });
    });

    return {
      check_bootstrap_environment: function () {
        var envs = ['xs', 'sm', 'md', 'lg'];
        var $el = $('<div>');

        $el.appendTo($('body'));

        for (var i = envs.length - 1; i >= 0; i--) {
          var env = envs[i];
          $el.addClass('hidden-' + env);
          if ($el.is(':hidden')) {
            $el.remove();
            return env;
          }
        }
      },
      get_bootstrap_environment: function () {
        if (bootstrap_environment == null) {
          bootstrap_environment = bp.bootstrap.check_bootstrap_environment();
        }
        return bootstrap_environment;
      },
      get_previous_bootstrap_environment: function () {
        return previous_bootstrap_environment;
      },
    };
  })(),
});

export {bp};
